import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { ViewportData, ViewportService } from '@shared/shared/viewport/common/abstract/viewport-service';
import { MOBILE_BREAKPOINT } from '../common/constants/mobile-breakpoint';
import { TABLET_BREAKPOINT } from '../common/constants/tablet-breakpoint';

@Injectable()
export class BrowserViewportService extends ViewportService {
  override viewPortChanged$: Observable<ViewportData> = fromEvent(window, 'resize').pipe(
    startWith(undefined),
    map(this.getViewportData)
  );

  isMobile$: Observable<boolean> = this.viewPortChanged$.pipe(
    map(e => e.width < MOBILE_BREAKPOINT),
    distinctUntilChanged()
  );

  isTablet$: Observable<boolean> = this.viewPortChanged$.pipe(
    map(e => e.width >= MOBILE_BREAKPOINT && e.width < TABLET_BREAKPOINT),
    distinctUntilChanged()
  );

  getViewportData(): ViewportData {
    return {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    };
  }
}
